import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { storeItem } from '#/shared/utils/storage';
import { ALERT_DISMISSED_KEY, ALERT_TIMESTAMP_KEY } from '#/shared/constants';
import { setAlertBannerVisibility } from '#/user/slice';

export default function useAlertBanner(newAlertTimestampKey = null) {
  const dispatch = useDispatch();
  const dismissBanner = useCallback(() => {
    dispatch(setAlertBannerVisibility(false));
    storeItem(ALERT_DISMISSED_KEY, true);
    if (newAlertTimestampKey)
      storeItem(ALERT_TIMESTAMP_KEY, newAlertTimestampKey);
  }, [dispatch, newAlertTimestampKey]);
  return { dismissBanner };
}
